module.exports = __webpack_public_path__ + "static/img/vx_ewm.488cb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/vx_ewm.png
// module id = rU88
// module chunks = 1